import type { AssetsSegmentSchemaWithIdPatched } from '@iconik-io/iconik-api/src/schema_patched/assets_segments';

type GetAllowedEditingCommentsArgs = {
  userId: string | undefined;
  shareUserEmail: string | undefined;
  shareSessionId?: string | undefined;
  allowComments: boolean;
  isCommentInScope: boolean;
  comment: AssetsSegmentSchemaWithIdPatched;
  canEditSegments: boolean;
  isInternalUser: boolean;
  canEditOtherUsersComments?: boolean;
};

export function getIsAllowedEditingComments({
  userId,
  shareUserEmail,
  shareSessionId,
  allowComments,
  isCommentInScope,
  comment,
  canEditSegments,
  isInternalUser,
  canEditOtherUsersComments,
}: GetAllowedEditingCommentsArgs) {
  // Copied some of the logic needed from packages/web/src/ducks/segments/selectors.ts
  // didn't want to remove the logic from there, as it is used in other places.

  if (!comment.share_user_email && !userId) {
    return false;
  }

  if (!allowComments) {
    return false;
  }

  // Internal users are not restricted to isCommentInScope — they can edit
  // across share contexts (e.g. when browsing an asset via a collection share
  // link). The isCommentInScope guard exists only to prevent share guests
  // from editing comments that belong to a different share.
  if (
    canEditOtherUsersComments &&
    canEditSegments &&
    (isInternalUser || isCommentInScope)
  ) {
    return true;
  }

  const isSameShareSession =
    Boolean(shareSessionId) && comment.share_session_id === shareSessionId;

  // Internal Iconik users must match by user_id only — not by email — to avoid
  // letting an authenticated user edit a guest comment posted with the same email.
  const isCommentAuthor =
    userId === comment.user_id ||
    (!isInternalUser &&
      (comment.share_user_email === shareUserEmail || isSameShareSession));

  if (
    isCommentAuthor &&
    canEditSegments &&
    (isInternalUser || isCommentInScope)
  ) {
    return true;
  }
  return false;
}
